import { AppAction } from 'actions/types/ActionTypes'
import { API_CALL } from 'actions/actionConstants'
import requestGetApprovalPolicy from 'businessTraveller/api/requestGetApprovalPolicy'
import { BUSINESS_TRAVELLER_API_ACTIONS } from 'reducers/businessTravellerApiActionReducers'

interface Params {
  refetch?: boolean
}

function fetchBusinessApprovalPolicy(
  businessId: string,
  params?: Params,
): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    const policy = state.businessTraveller.businessApprovalPolicy.policy
    const currentBusinessUser = state.businessTraveller.currentBusinessAccount?.employee

    const shouldFetch = (!policy && currentBusinessUser) || (params?.refetch && currentBusinessUser)
    if (shouldFetch) {
      dispatch({
        type: API_CALL,
        api: BUSINESS_TRAVELLER_API_ACTIONS.FETCH_BUSINESS_APPROVAL_POLICY,
        request: () => requestGetApprovalPolicy({
          businessId,
          employeeId: currentBusinessUser.id,
        }),
      })
    }
  }
}

export default fetchBusinessApprovalPolicy
